import React from 'react';
import FeatureSummary from "../../../../Util/FeatureSummary";
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';

const ChecklistDashboardTable = ({
    configs,
    loading,
    editOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                    id={item.coBrandID}
                    item={item}
                />
            ),
        },
        {
            name: 'Cobrand',
            fieldName: 'coBrandName',
            minWidth: 200,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
        },
        {
            name: 'Checklists',
            fieldName: 'checklistCount',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
        },
    ];

    const items = configs ?? [];

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                loading={loading}
                mainColumn={'coBrandName'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Add' }}
                        text="Add Checklist Dashboard"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                summary="This table lists every cobrand that has the Checklist Dashboard (Learning Journeys) enabled, along with the number of checklists surfaced. Use the menu to edit a cobrand's configuration or disable the dashboard."
                label="About Checklist Dashboards"
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'edit',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: 'delete',
                iconProps: { iconName: 'Delete' },
                text: 'Disable',
                onClick: () => deleteOnClick(id, item?.coBrandName || ''),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default ChecklistDashboardTable;
